import { render, staticRenderFns } from "./PromotionApplyRoomTypeComponent.vue?vue&type=template&id=b4565b82&scoped=true"
import script from "./PromotionApplyRoomTypeComponent.vue?vue&type=script&lang=js"
export * from "./PromotionApplyRoomTypeComponent.vue?vue&type=script&lang=js"
import style0 from "./PromotionApplyRoomTypeComponent.vue?vue&type=style&index=0&id=b4565b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4565b82",
  null
  
)

export default component.exports